// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19Jww","toggle":"styles_toggle__CzL5B","preview":"styles_preview__3NseZ"};